<template>
    <div>
        <el-row :gutter="20" style="border: 1px solid #e2e7ed">


            <el-col>

                <div class="tip" style="padding: 35px 35px 21px 35px;display: flex">
                    <slot name="main"></slot>
                    <div v-if="!onlyRead || (userInfo.cat_profile_id == 3 && requestForm.last_log.cat_acquisition_status_id == 56 && (sectionId == 6 || sectionId == 5))">
                        <upload-document buttonName="Agregar Documento"
                                         @fileInfo="addFileToRequest"
                                         v-if="checkOnlyOne(onlyOneAlias,filterSection(model))
										 || (userInfo.cat_profile_id == 3 && requestForm.last_log.cat_acquisition_status_id == 56)"/>
                    </div>
                </div>


                <el-table :data="filterSection(model)" size="small" style="width: 100%">
                    <el-table-column
                            label="Nombre de archivo"
                            min-width="200px">
                        <template slot-scope="scope">
                            {{scope.row.fileName ? scope.row.fileName : ''}}
                            <span v-if="scope.row.file">
                              {{  scope.row.file.fileName}}
                         </span>
                        </template>
                    </el-table-column>

                    <el-table-column
                            label="Descripción"
                            min-width="200px">
                        <template slot-scope="scope">

                            <el-input v-model="scope.row.description"
                                      :maxlength="500"
                                      v-if="scope.row.id"
                                      :disabled="onlyRead == true ? true: false"
                                      placeholder="">
                            </el-input>
                            <el-input v-model="scope.row.description"
                                      :maxlength="500"
                                      v-if="!scope.row.id"

                                      placeholder="">
                            </el-input>

                        </template>
                    </el-table-column>


                    <el-table-column label="Opciones de edición" align="center" min-width="160">
                        <template slot-scope="scope">

                            <div>
                                <el-button-group>
                                    <el-tooltip
                                            v-if="scope.row.file_id"
                                            class="item"
                                            effect="dark"
                                            content="Ver documento"
                                            placement="top-end">
                                        <el-button
                                                size="small"
                                                icon="el-icon-view"
                                                @click="showPdf(scope.row.file_id)">
                                        </el-button>
                                    </el-tooltip>
                                    <el-tooltip
                                            v-if="!(userInfo.cat_profile_id == 3 && requestForm.last_log.cat_acquisition_status_id == 56 && (sectionId == 6 || sectionId == 5))"
                                            class="item"
                                            effect="dark"
                                            content="Eliminar documento"
                                            placement="top-end">
                                        <el-button
                                                size="small"
                                                type="danger"
                                                @click="removeDocument(scope.row)">
                                            <i class="fas fa-trash"></i>
                                        </el-button>
                                    </el-tooltip>
                                    <el-tooltip
                                            v-if="(userInfo.cat_profile_id == 3 && requestForm.last_log.cat_acquisition_status_id == 56 && (sectionId == 6 || sectionId == 5))"
                                            class="item"
                                            effect="dark"
                                            content="Eliminar documento"
                                            placement="top-end">
                                        <el-button
                                                :disabled="!(scope.row.id == null)"
                                                size="small"
                                                type="danger"
                                                @click="removeDocument(scope.row)">
                                            <i class="fas fa-trash"></i>
                                        </el-button>
                                    </el-tooltip>
                                </el-button-group>
                            </div>
                        </template>

                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <ShowDocuments :closeShowDocument="closeShowDocument"
                       :activeShowDocument="activeShowDocument"
                       :fileNameHash="fileNameHash"
                       v-if="activeShowDocument"/>
    </div>
</template>
<script>
    import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
    import UploadDocument from '@/utils/UploadDocument';
    import ShowDocuments from '@/utils/ShowDocuments';

    export default {

        components: {
            UploadDocument,
            ShowDocuments
        },
        props: {
            sectionId: {
                required: true
            },
            onlyRead: {
                required: true
            },
            onlyOne: {
                type: Boolean
            }
        },
        data() {
            return {
                item: null,
                fileData: {},
                fileNameHash: null,
                activeShowDocument: false,
                disabledButton: false
            }
        },

        computed: {
            ...mapGetters('form', {
                catalogs: 'catalogs',
                requestForm: "requestForm",
                //onlyRead: "onlyRead"
            }),
            ...mapGetters(["userInfo"]),
            onlyOneAlias() {
                return this.onlyOne && this.onlyOne === true ? true : false;
            },
            model() {
                return this.requestForm && this.requestForm.documents ? this.requestForm.documents : [];
            }
        },
        methods: {
            ...mapMutations('form', {
                addDoc: "addDoc",
                removeDocumentStore: "removeDocument"
            }),
            filterSection(data) {
                let filterData = data.filter((item) => item.section_id == this.sectionId);
                return filterData;
            },
            checkOnlyOne(onlyOne, data) {

                if (!onlyOne) return true;
                if (!data) return false;

                if (onlyOne === true && data.length >= 1) {
                    return false;
                }

                return true;
            },
            showPdf(id) {


                let _self = this;
                let url = '/api/get-hash-file/' + id;

                var xhr = new XMLHttpRequest();
                xhr.open('PUT', url, false);
                xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                xhr.setRequestHeader('Authorization', 'Bearer ' + window.sessionStorage.getItem('acquisition_token'));

                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            var data = JSON.parse(xhr.responseText);
                            _self.fileNameHash = data.fileNameHash;
                            _self.activeShowDocument = true;
                        } else {
                            console.log("error");
                        }
                    }
                }
                xhr.send();

            },
            closeShowDocument() {
                this.activeShowDocument = false;
            },
            removeDocument(item) {
                this.$confirm('¿Desea eliminar este documento?').then(confirm => {
                    this.removeDocumentStore(item);
                }).catch(e => {

                });

            },
            addFileToRequest(fileInfo) {
                let payload = {
                    section_id: this.sectionId,
                    file_id: fileInfo.id,
                    fileName: fileInfo.fileName,
                };
                this.addDoc(payload)
            },

            disabledSection() {
                var keys = Object.keys(my_array);
                var last = keys[keys.length - 1];
            }
        }
    };

</script>

